<template>
  <v-content class="content_body">
    <v-flex xs12>
      <v-layout row wrap>
        <!-- Pesquisa de tomador -->
        <v-flex xs12 v-if="taker.stepType == 1">
          <v-layout row wrap>
            <v-flex>
              <v-text-field
                :placeholder="'Pesquisar'"
                :label="'Digite o CNPJ do tomador'"
                @input="unselectTaker"
                @click:append="getTakerByCNPJ"
                @keyup.enter="getTakerByCNPJ()"
                v-model="taker.cnpj"
                v-mask="'##.###.###/####-##'"
                :rules="[rules.obrigatorio, rules.cnpjInvalido]"
                class="jns-input"
                id="emissao_tomador_input_search"
              >
              <template v-slot:append>
              <v-icon class="mt-1 mr-1 input_search"  id="search_tomador"  @click="getTakerByCNPJ()">search</v-icon>
              </template>
            </v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- ./Pesquisa de tomador -->

        <!-- Titulo e Retorno Pesquisa de tomador -->
        <v-flex
          md6
          sm12
          class="no-padding-bottom mt-0"
          v-if="taker.stepType == 1 && taker.info"
        >
          <h2 v-html="stepTitles[step - 1]"></h2>

          <div
            class="pull-right bold no-padding-top no-padding-bottom p-rel mt-30neg"
            v-if="
              taker.stepType == 1 &&
                taker.info &&
                taker.info.status_nomeado == 'SEM_NOMEACAO'
            "
          >
            <span class="info-red">
              Tomador liberado ao mercado
              <v-icon
                class="info-red custom-i"
                @mouseover="showMsgTomador = true"
                @mouseleave="showMsgTomador = false"
                >info</v-icon
              >
            </span>
            <div class="msg-tomador-container" v-if="showMsgTomador">
              <p class="info-red">Tomador liberado</p>
              <p>
                Para bloqueá-lo solicite uma emissão, formalize o contrato de
                contragarantias ou anexe uma carta de nomeação.
              </p>
            </div>
          </div>

          <!-- Retorno Pesquisa de tomador -->
          <person-info-box
            :info="taker.info"
            :show-unselect-button="false"
            :class="
              taker.stepType == 1 &&
              taker.info &&
              taker.info.status_nomeado == 'SEM_NOMEACAO'
                ? ''
                : 'mt-0'
            "
          ></person-info-box>
          <!-- ./Retorno Pesquisa de tomador -->

          <!-- Carta de nomeação -->
          <div
            v-if="
              taker.stepType == 1 &&
                taker.info &&
                taker.info.status_nomeado != 'CORRETOR_NOMEADO'
            "
          >
            <tomador-carta-nomeacao
              :idTomador="taker.info.id"
              :statusNomeado="taker.info.status_nomeado"
              @complete="handleOutroNomeadoCartaUpload"
            ></tomador-carta-nomeacao>
          </div>
          <!-- ./Carta de nomeação -->
        </v-flex>
        <!-- ./Titulo e Retorno Pesquisa de tomador -->

        <!-- Titulo e Retorno Calculando Limites -->
        <v-flex
          md6
          sm12
          class="no-padding-bottom"
          v-if="
            taker.stepType == 1 &&
              taker.info &&
              taker.info.status_nomeado != 'OUTRO_NOMEADO'
          "
        >
          <h2>Limites e taxas do tomador</h2>
          <limites-taxas
            :class="erroBuscaLimite ? 'mt-2 mb-5' : 'mb-5'"
            :carregando="buscandoLimite"
            :erroBuscaLimite="erroBuscaLimite"
            :msgErroBuscaLimite="msgErroBuscaLimite"
            :taker="taker"
            :step="step"
            :tipo_pessoa="this.tipo_pessoa"
          ></limites-taxas>
        </v-flex>
        <!-- ./Titulo e Retorno Calculando Limites -->
      </v-layout>
    </v-flex>
  </v-content>
</template>
<script lang="js">
import { isValidCnpj } from "@/libs/utils";
import ViewMixin from "@/mixins/ViewMixin";

export default {
  name: "TomadorPasso1",
  mixins: [ViewMixin],
  props: [
    "taker",
    "step",
    "buscandoLimite",
    "unselectTaker",
    "stepTitles",
    "product",
    "tipo_pessoa",
    "msgErroBuscaLimite",
    "erroBuscaLimite"
  ],
  data() {
    return {
      showMsgTomador: false,
      rules: {
        obrigatorio: (value) => !!value || "Campo obrigatório.",
        cnpjInvalido: (v) =>
          (!!v && isValidCnpj(v)) || "Número de documento inválido",
      }
    };
  },
  methods: {

    async getTakerByCNPJ() {

      if (!this.taker.cnpj) return;

      if (isValidCnpj(this.taker.cnpj)) {
        let data;
        let cnpj = this.taker.cnpj.replace(/[^\w\s]/gi, "");
        let pesquisouTomador = false;
      
        this.showLoadingAskWait();

        // Pesquisa o tomador que pode estar com ou sem limites
        try {
          pesquisouTomador = true;
          data = await this.$store.dispatch("GET_TAKER_DATA", { cnpj });
        } catch (e) {
          if (e && e[0] && !e[0].ativo) {
            return this.handleInactivePersonError(e[0], "Tomador");
          }
          e.response.data.id="passo1erros"
          this.handlerErrors(e);
          pesquisouTomador = false;
        } finally {
          this.hideLoadingAskWait();
        }

        if (!data) return;
        if (!pesquisouTomador) return;
        this.$emit("setTaker", data);
      }
    },

    handleOutroNomeadoCartaUpload() {
      let t = this;
      let options = {
        title: `Documento enviado com sucesso!`,
        message: `Aguarde a notificação da avaliação da Carta de Nomeação, para seguir com a proposta.`,
        callback: this.cartaNomeacao,
      };

      this.setErrorModal(options);
    },

    cartaNomeacao() {
      this.$emit("quitProposal");
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>
<style lang="scss">
#jns {
  .content_body {
    padding: 20px 40px 77px 40px !important;
    background-color: white;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/router/views/Propostas/Passos/Tomador.vue